export interface GtmData {
    name: string
    value: string
}

export enum UserAction {
    Add = "Legg til",
    Save = "Lagre",
    Remove = "Fjerne",
    ClickOn = "Klikk på",
    TurnOn = "Skru på",
    TurnOff = "Skru av",
    View = "Vis",
    Open = "Åpne",
    Close = "Lukk",
    Start = "Start",
    Finish = "Fullfør",
    Scroll = "Scroll",
}

export enum DinnerSuggestionSubject {
    StartOnboarding = "kom i gang",
    Next = "neste",
    NextStep = "neste steg",
    Skip = "hopp over",
    Back = "tilbake",
    Close = "lukk",
    Finish = "fullfør",
    AnalyticalConsent = "analytisk samtykke",
    AnalyticalConsentLink = "analytisk samtykke lenke",
    IntroDialog = "introdialog lukk knapp",
    GoToRecipes = "gå til oppskrifter",
    Personalization = "personalisering",
    CookieBannerLink = "cookie banner lenke",
    ScrollMorePersonalizedRecipes = "flere personlige oppskrifter",
    SeePersonalizedRecipe = "se personaliserte oppskriften",
    SeeAllPurchasedRecipes = "se alle kjøpte oppskrifter",
    SeeAllSavedRecipes = "se alle lagrede oppskrifter",
    PersonalizedRecipe = "personalisert oppskrift",
    RecipeInCart = "oppskrift i handlevognen",
    PersonalizedRecipeInCart = "personalisert oppskrift i handlevognen-popup",
    EditPreferences = "endre preferanser",
    SavePreferences = "lagre preferanser",
}

export enum TrackingEvents {
    Recipes = "oppskrifter",
}

export enum TrackingCategory {
    DinnerSuggestionOnboarding = "Onboarding",
    DinnerSuggestions = "Middagsforslag",
}

export enum TrackingEventPage {
    RecipesPage = "Oppskrifter",
    MyRecipes = "Mine oppskrifter",
    DinnerSuggestionOnboarding = "Middagstips-onboarding",
    DinnerSuggestionPreferences = "Middagstips-preferanser",
    ConsentPopup = "consent-popup",
    InfoPopup = "info-popup",
}
